/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useContext } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { Menu, MenuItem, Skeleton } from "@mui/material";
import { MODULE_MASTER } from "utils/constant"
import CrudService from "services/cruds-service";
import { toast } from 'react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';
import ModalContact from "../add-contact";
import ModalSelectContact from "../add-contact/select";
import { AuthContext } from "context";

const EditContactEntity = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [name, setName] = useState({
        text: "",
        error: false,
        textError: "",
    });

    ///////////////// contact addresss ////////////////
    const [contactType, setContactType] = useState([]);
    const [contactStatusType, setContactStatusType] = useState([]);
    const [statusContact, setStatusContact] = useState([]);
    const [phoneAddresses, setPhoneAddresses] = useState([]);
    const [emailAddresses, setEmailAddresses] = useState([]);
    const [faxAddresses, setFaxAddresses] = useState([]);
    const [selectedPhoneId, setSelectedPhoneId] = useState(0);
    const [selectedEmailId, setSelectedEmailId] = useState(0);
    const [selectedFaxId, setSelectedFaxId] = useState(0);
    const [contacts, setContacts] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [openSelect, setOpenSelect] = useState(false);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [loader, setLoader] = useState(true)
    const [entityAddressItemList, setEntityAddressItem] = useState([])

    const [contact_first_name, setContactFirstName] = useState({
        text: "",
        error: false,
        textError: "",
    });
    const [contact_last_name, setContactLastName] = useState({
        text: "",
        error: false,
        textError: "",
    });

    const [notification, setNotification] = useState({
        value: false,
        text: "",
    });
    const authContext = useContext(AuthContext)

    // const [descError, setDescError] = useState(false);

    useEffect(() => {
        (async () => {
            const response = await CrudService.getContacts();
            setContacts(response.data);
        })();

    }, []);

    useEffect(() => {
        if (!id || id == 'null') {
            setLoader(false)
            return;
        };
        (async () => {
            try {
                const res = await CrudService.getEntityContact(id);
                if(res?.success){
                    setSelectedContacts(res.data);
                    setEntityAddressItem(res.entityAddressItems)
                }
                setLoader(false);
            } catch (err) {
                console.error(err);
            }
        })();
    }, [id]);


    useEffect(() => {
        if (notification.value === true) {
            let timer = setTimeout(() => {
                setNotification({
                    value: false,
                    text: "",
                });
            }, 5000);
        }
    }, [notification]);

    const submitHandler = async (e) => {
        e.preventDefault();

        let selectedContactIDs = selectedContacts.map(contact => contact?.attributes?.contact_id);

        const updatedEntity = {
            selectedContactIDs: selectedContactIDs,
            contact: {
                contact_first_name: contact_first_name.text,
                contact_last_name: contact_last_name.text,
                contactType: contactType?.attributes,
                contactStatusType: contactStatusType?.attributes,
                phoneAddresses,
                emailAddresses,
                faxAddresses,
                selectedPhoneID: selectedPhoneId,
                selectedEmailID: selectedEmailId,
                selectedFaxID: selectedFaxId
            },
        };

        if([null, 'null', undefined].includes(id)){
            navigate(`/entity-management/new-entity`, {
                state: { value: updatedEntity, text: "contact detail" },
            });
            return
        }

        try {
            authContext.startLoading()
            await CrudService.updateContactAccess(id, updatedEntity);
            navigate(`/entity-management/edit-entity/${id}`, {
                state: { value: true, text: "The entity was successfully Updated" },
            });
            toast.success('Updated Successfully')
        } catch (err) {
            if (err.hasOwnProperty("errors")) {
                setName({ ...name, error: true, textError: err.errors[0].detail });
            } else {
                toast.error(err.error);
            }
            console.error(err);
        } finally {
            authContext.stopLoading()
        }
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleNewClick = () => {
        setAnchorEl(null);
        setOpen(true);
    };

    const handleSelectClick = () => {
        setAnchorEl(null);
        setOpenSelect(true);
    };

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleMenuClick = (event) => {
        // Prevent the menu from closing when clicking inside it
        event.stopPropagation();
    };

    const handleBack = () => {
        if([null, 'null', undefined].includes(id)){
            navigate(`/entity-management/new-entity`, {
                state: { value: {}, text: "" },
            })
        } else {
            navigate(`/entity-management/edit-entity/${id}`, {
                state: { value: false, text: "" },
            })
        }
    }


    return (
        <DashboardLayout>
            <DashboardNavbar />
            {/* <ToastContainer/> */}
            {notification.value && (
                <MDAlert
                    color={notification.bgColor}
                    my="20px"
                    sx={{
                        position: "sticky",
                        top: { md: "100px", xs: "50px" },
                        zIndex: "10000",
                    }}
                >
                    <MDTypography variant="body2" color="white">
                        {notification.text || ""}
                    </MDTypography>
                </MDAlert>
            )}
            <MDBox mb={9}>
                <Grid justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    {[null, 'null', undefined].includes(id) ? 'Add Entity Contact' : `Edit Entity Contact ${id}`}
                                </MDTypography>
                            </MDBox>
                            <MDTypography variant="h5" fontWeight="regular" color="secondary">
                                This information will describe more about the entity.
                            </MDTypography>
                        </MDBox>
                        <Card>
                            <MDBox component="form" method="POST" onSubmit={submitHandler}>
                                <MDBox display="flex" flexDirection="column" px={3} my={2}>
                                    {
                                        loader ?
                                            <Skeleton variant="rectangular" height={200} sx={{ margin: '10px 0' }} /> :
                                            <Card>
                                                <MDBox
                                                    display="flex" px={3} my={2}
                                                >
                                                    <MDTypography variant="h5" fontWeight="bold">
                                                        Contacts
                                                    </MDTypography>
                                                    <MDButton variant="gradient" color="dark" size="small" style={{ marginLeft: "1.8rem" }} onClick={handleClick}>
                                                        + Add Contact
                                                        <Menu
                                                            anchorEl={anchorEl}
                                                            open={Boolean(anchorEl)}
                                                            onClose={handleClose}
                                                            onClick={handleMenuClick}
                                                        >
                                                            <MenuItem onClick={handleNewClick}>New Contact</MenuItem>
                                                            <MenuItem onClick={handleSelectClick}>Select Contact(s)</MenuItem>
                                                        </Menu>
                                                    </MDButton>
                                                </MDBox>
                                                {
                                                    <ModalContact
                                                        open={open} setOpen={setOpen}
                                                        contactType={contactType} setContactType={setContactType}
                                                        contactStatusType={contactStatusType} setContactStatusType={setContactStatusType}
                                                        statusContact={statusContact} setStatusContact={setStatusContact}
                                                        phoneAddresses={phoneAddresses} setPhoneAddresses={setPhoneAddresses}
                                                        emailAddresses={emailAddresses} setEmailAddresses={setEmailAddresses}
                                                        faxAddresses={faxAddresses} setFaxAddresses={setFaxAddresses}
                                                        selectedPhoneId={selectedPhoneId} setSelectedPhoneId={setSelectedPhoneId}
                                                        selectedEmailId={selectedEmailId} setSelectedEmailId={setSelectedEmailId}
                                                        selectedFaxId={selectedFaxId} setSelectedFaxId={setSelectedFaxId}
                                                        contact_first_name={contact_first_name} setContactFirstName={setContactFirstName}
                                                        contact_last_name={contact_last_name} setContactLastName={setContactLastName}
                                                    />
                                                }
                                                {
                                                    <ModalSelectContact
                                                        open={openSelect} entityId={id} setOpen={setOpenSelect} contacts={contacts} selectedContacts={selectedContacts} setSelectedContacts={setSelectedContacts} entityAddressItemList={entityAddressItemList}
                                                    />
                                                }

                                            </Card>
                                    }
                                    <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                                        <MDBox mx={2}>
                                            <MDButton
                                                variant="gradient"
                                                color="dark"
                                                size="small"
                                                px={2}
                                                mx={2}
                                                onClick={() => handleBack()}
                                            >
                                                Back
                                            </MDButton>
                                        </MDBox>
                                        <MDButton variant="gradient" color="dark" size="small" type="submit">
                                            Save
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default EditContactEntity;
